import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleProjectClick = (e) => {
        e.preventDefault();
        window.location.href = "/#projects";
        setMenuOpen(false);
    };

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => setMenuOpen(false);

    return (
        <div className="navbar">
            {/* Mobile menu icon */}
            <div className="menu-icon" onClick={handleMenuToggle}>
                <span>&#9776;</span>
            </div>

            <div className={`nav-linksone ${menuOpen ? "open" : ""}`}>
                <Link to="/" onClick={closeMenu}>Home</Link>
                <a href="/#projects" onClick={handleProjectClick}>Projects</a>
                <Link to="/aboutme" onClick={closeMenu}>About Me</Link>
            </div>
        </div>
    );
};

export default Navbar;
